import { Component, OnInit, Input } from '@angular/core';
import { FormBaseConfig, FieldConfig, FormInline } from '../../models/form-field.model';
import { FormGroup } from '@angular/forms';
import { FormConfigInstance } from '../../services/form.service';

@Component({
  selector: 'gio-form-inline',
  templateUrl: './form-inline.component.html',
  styleUrls: ['./form-inline.component.scss'],
  host: {
    '[style]': 'params.options?.hostStyle'
  },
})
export class FormInlineComponent implements OnInit {

  @Input() service: FormConfigInstance;
  @Input() form: FormGroup;

  params: FormInline;

  constructor() { }

  ngOnInit(): void {
    this.params = this.service.params as FormInline;
  }
}
